import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

/** Mapeo opcional: tamaño “humano” → tamaño Chakra. */
const SIZE_TO_CHAKRA = {
  sm: "md",
  md: "lg",
  lg: "2xl",
  xl: "4xl",
  full: "full",
};

/**
 * Modal reutilizable (Chakra UI). Envuelve título, cuerpo y pie opcional.
 *
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {React.ReactNode} title
 * @param {React.ReactNode} children — cuerpo principal
 * @param {React.ReactNode} [footer] — botones u acciones al pie
 * @param {"sm"|"md"|"lg"|"xl"|"full"} [size]
 * @param {"inside"|"outside"} [scrollBehavior]
 */
export default function AppModal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = "lg",
  scrollBehavior = "inside",
  closeOnOverlayClick = true,
}) {
  const chakraSize =
    typeof size === "string" && SIZE_TO_CHAKRA[size]
      ? SIZE_TO_CHAKRA[size]
      : size;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={chakraSize}
      scrollBehavior={scrollBehavior}
      closeOnOverlayClick={closeOnOverlayClick}
      isCentered
      motionPreset="slideInBottom"
    >
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
      <ModalContent
        mx={{ base: 3, md: "auto" }}
        my={{ base: 3, md: "auto" }}
        maxH={{ base: "92vh", md: "90vh" }}
        className="rounded-xl border border-gray-100 bg-white shadow-xl dark:border-white/10 dark:bg-navy-800 dark:text-white"
      >
        <ModalHeader
          className="font-dm text-navy-700 dark:text-white"
          pb={2}
          pt={6}
          pr={12}
        >
          {title}
        </ModalHeader>
        <ModalCloseButton className="text-gray-500 hover:text-brand-500" />
        <ModalBody className="font-dm text-navy-700 dark:text-gray-200" pb={4}>
          {children}
        </ModalBody>
        {footer != null ? (
          <ModalFooter className="gap-2 border-t border-gray-100 dark:border-white/10">
            {footer}
          </ModalFooter>
        ) : null}
      </ModalContent>
    </Modal>
  );
}
